module.exports = __webpack_public_path__ + "img/logo_old.70918269.png";